import LeadCard from './leadCard.view';

export default LeadCard;
